import React, { useState, useEffect, useCallback } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import DatePicker from "react-datepicker";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import {
  getAllProductsSupplierlist,
  getSupplierById,
  getSuppliersList,
} from "../../../service/Suppliers/SuppliersService";
import {
  getAllDepartmentDetailslist,
  getAllMyDepartmentDetailslist,
} from "../../../service/Department/DepartmentService";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import instance from "../../../WebApi/WebApi";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";

const Createpurchaseorder = () => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState();
  const [SupplierDataList, setAllSupplierDataList] = useState([]);
  const [getSupplierId, setSupplierId] = useState({});
  const [supId, setSupId] = useState();
  const [buId, setBU] = useState();
  const [invoiceId, setInvoiceId] = useState();
  const [myDepartmentList, setAllMyDepartmentList] = useState([]);
  const [department, setDepartment] = useState("");
  const [count, setCount] = useState([]);
  const [cartCount, setCartCount] = useState([]);
  const [indexArray, setIndexArray] = useState([]);
  const [cartindexArray, setCartIndexArray] = useState([]);
  const [departmentList, setAllDepartmentList] = useState([]);
  const [formData, setFormData] = useState();
  const [businesUnitData, setAllBusinessUnit] = useState([]);
  const [supplierProduct, setSupplierProduct] = useState([]);
  const [originalProductList, setOriginalProductList] = useState([]);
  const [checkedProduct, setCheckedProduct] = useState([]);
  const [cartcheckedProduct, setCheckedCartProduct] = useState([]);
  const [busketData, setBusketData] = useState([]);
  const [totalPrice, setTotalPrice] = useState();
  const [totalCO2, setTotalCO2] = useState();

  const [selectedOption, setSelectedOption] = useState("With_VAT");

  const handleChangeCheckbox = (event) => {
    setSelectedOption(event.target.id); // Update state with the selected radio button's ID
  };

  const validationSchema = Yup.object({
    productId: Yup.string().required("Product Id is required"),
    productName: Yup.string().required("Product Name is required"),
    base_qty: Yup.number()
      .required("Quantity is required")
      .positive("Quantity must be greater than 0")
      .integer("Quantity must be an integer"),
    price: Yup.number()
      .required("Price is required")
      .positive("Price must be greater than 0"),
    vat: Yup.number()
      .positive("VAT must be greater than or equal to 0")
      .max(100, "VAT cannot be more than 100"),
    discount: Yup.number()
      .min(0, "Discount cannot be negative")
      .max(100, "Discount cannot be more than 100"),
    co2: Yup.number().min(0, "Carbon footprint cannot be negative"),
  });
  const handleIncrement = (i) => {
    setCount({ ...count, [i]: count[i] + 1 });
  };

  const handleDecrement = (i) => {
    if (count[i] > 0) {
      setCount({ ...count, [i]: count[i] - 1 });
    }
  };
  const cartItemIncrement = (i) => {
    setCartCount({ ...cartCount, [i]: cartCount[i] + 1 });
  };

  const cartItemDecrement = (i) => {
    if (cartCount[i] > 0) {
      setCartCount({ ...cartCount, [i]: cartCount[i] - 1 });
    }
  };
  console.log("count", count);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getInvoiceSupplierDataList();
    // getMyDepartmentDataList();
    getBussinessUnit();
  }, []);

  //list of suppliers
  async function getInvoiceSupplierDataList() {
    getSuppliersList().then(function (result) {
      const response = result?.data;
      setAllSupplierDataList(response?.data?.listSupplier);
    });
  }

  async function getBussinessUnit() {
    getAllIndustryDetailslist("").then(function (result) {
      const response = result.data;
      setAllBusinessUnit(response?.data);
    });
  }
  const handleChangeBU = (id) => {
    setBU(id);
    getDepartmentList(id);
  };

  const getDepartmentList = async (id) => {
    const data = {
      businessUnitId: id,
    };
    const response = await instance.post(
      `/customer/department/list-department-business-id`,
      data
    );
    setAllMyDepartmentList(response?.data?.data?.departmentList);
  };

  async function getallSupplierList(id) {
    getSupplierById(id).then(function (result) {
      const response = result.data;
      console.log(response, "response");
      setSupplierId(response?.data?.supplierDetails);
      getallSupplierProductsList(id);
    });
  }
  async function getMyDepartmentDataList() {
    getAllMyDepartmentDetailslist().then(function (result) {
      console.log(result.data, "datadatadatadatada");
      const response = result.data;
      console.log(response, "rrrr");
      setAllMyDepartmentList(response?.data?.departmentList);
    });
  }
  const handleDropdown = (id) => {
    setSupId(id);
    getallSupplierList(id);
    getBasketData(id);
  };
  const getBasketData = async (id) => {
    const data = {
      supplierId: id,
    };
    const response = await instance.post(
      `/customer/purchase-order/get-basket-list-by-supplier`,
      data
    );
    setBusketData(response?.data?.data);
    const countData = response?.data?.data?.map((d, i) => Number(d?.quantity));
    setCartCount(countData);
  };

  async function getallSupplierProductsList(id) {
    getAllProductsSupplierlist(id).then(function (result) {
      const response = result.data;
      console.log(response, "response");
      const countData = response?.data?.listProduct.map((d, i) => 0);
      setCount(countData);
      setSupplierProduct(response?.data?.listProduct);
      setOriginalProductList(response?.data?.listProduct);
    });
  }

  const onDepartment = (e) => {
    setDepartment(e.target.value);
    getAllDepartmentDetailslist("", e.target.value).then(function (result) {
      const response = result.data;
      setAllDepartmentList(response?.data?.departmentList);
    });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleAdd = async (values) => {
    // e.preventDefault();
    console.log("formData", values);
    const data = {
      supplierId: supId,
      number: values?.productId,
      name: values?.productName,
      baseUnit: values?.base_qty,
      baseUnitPrice: "",
      purchasePrice: "",
      currencyType: "",
      VATPercent: values?.vat,
      saleUnitQty: "",
      subUnitQty: "",
      grossWeight: "",
      netWeight: "63",
      PackageMaterialForSubUnit: "",
      PackageMaterialForSaleUnit: "",
      salePrice: values?.price,
      discount: values?.discount,
      manufactureProductNumber: "466",
      manufactureName: "awew",
      country: "AX",
      base_unit_of_measure: "Pcs",
      sale_unit_of_measure: "Ltr",
      sub_unit_of_measure: "",
      web_store_url: "",
      product_web_store_url: "",
      amt_purchase_price: "",
      co2_unt_measure: "",
      co2_qty: "",
      co2_data: "",
      unspscData: "",
      kgco2_co2_unit: values?.co2,
    };

    if (supId) {
      try {
        await instance.post(`/customer/supplier/add-product-supplier`, data);
        toast.success("Successfully added");
        getallSupplierProductsList(supId);
      } catch (err) {
        console.log(err);
      }
    } else {
      toast.error("Please select supplier");
    }
  };

  useEffect(() => {
    getTotalPrice();
    totalCarbonFootPrint();
  }, [count]);

  const getTotalPrice = useCallback(() => {
    const total = supplierProduct.reduce(
      (acc, item, index) => acc + Number(item?.salePrice) * count[index],
      0
    );
    setTotalPrice(total);
  }, [count]);
  const totalCarbonFootPrint = useCallback(() => {
    const total = supplierProduct.reduce(
      (acc, item, index) => acc + Number(item?.kgco2_co2_unit) * count[index],
      0
    );
    setTotalCO2(total);
  }, [count]);

  const handleSearch = (e) => {
    const searchText = e.toLowerCase();
    if (searchText) {
      const filterData = originalProductList.filter(
        (d) =>
          d?.number.toLowerCase().includes(searchText) ||
          d?.name.toLowerCase().includes(searchText)
      );
      console.log("filterData", searchText, filterData, originalProductList);
      setSupplierProduct(filterData);
    } else {
      setSupplierProduct(originalProductList);
    }
  };
  const isSelected = (id) => {
    return checkedProduct.some((item) => item.id === id);
  };

  const handleCheckCart = (data, i) => {
    if (isSelected(data.id)) {
      setCheckedProduct((prevSelected) =>
        prevSelected.filter((selectedItem) => selectedItem.id !== data.id)
      );
      setIndexArray((prevSelected) =>
        prevSelected.filter((selectedItem) => selectedItem !== i)
      );
    } else {
      setCheckedProduct((prevSelected) => [...prevSelected, data]);
      setIndexArray((prevSelected) => [...prevSelected, i]);
    }
  };
  const isCartSelected = (id) => {
    return cartcheckedProduct.some((item) => item.id === Number(id));
  };

  const handleCheckCartModal = (data, i) => {
    if (isCartSelected(data.id)) {
      setCheckedCartProduct((prevSelected) =>
        prevSelected.filter((selectedItem) => selectedItem.id !== data.id)
      );
      setCartIndexArray((prevSelected) =>
        prevSelected.filter((selectedItem) => selectedItem !== i)
      );
    } else {
      setCheckedCartProduct((prevSelected) => [...prevSelected, data]);
      setCartIndexArray((prevSelected) => [...prevSelected, i]);
    }
  };
  const validate = () => {
    let flag = true;
    if (!invoiceId) {
      toast.error("Please provide invoice id");
      flag = false;
    } else if (!department) {
      toast.error("Please select department");
      flag = false;
    } else if (!buId) {
      toast.error("Please select operator unit");
      flag = false;
    } else if (!startDate) {
      toast.error("Please select date");
      flag = false;
    }
    return flag;
  };

  const handleCreateOrder = async () => {
    if (validate()) {
      const products = checkedProduct?.map((d, i) => ({
        id: d?.id,
        productName: d?.name,
        vat: d?.VATPercent,
        discount: d?.discount,
        totalAmount: count[indexArray[i]] * d?.salePrice,
        quantity: count[indexArray[i]],
        CarbonFootPrint: d?.kgco2_co2_unit,
        unitPrice: d?.salePrice,
      }));

      const data = {
        invoiceId: invoiceId,
        totalAmount: totalPrice,
        filterCarbonFootPrint: totalCO2,
        supplierId: supId,
        products: products,
        businessUnitId: buId,
        departmentId: department,
        deliveryDateTime: startDate,
      };
      try {
        const response = await instance.post(
          `/customer/purchase-order/create-purchase-order`,
          data
        );

        toast.success(response?.data?.message);
        setCheckedProduct([]);
        setCheckedCartProduct([]);
        setCartIndexArray([]);
        setIndexArray([]);
        setShow(false);
        navigate(`/purchaseorderdetail?id=${response?.data?.data?.id}`);
        // navigate(`/purchaseorder`);
      } catch (err) {
        toast.error(err?.response?.data?.message);
      }
    }
  };
  const handleCreateOrderandSaveBasket = async () => {
    let products = [];
    if (show) {
      products = busketData?.map((d, i) => ({
        id: d?.productId,
        productName: d?.productName,
        vat: d?.vat,
        discount: d?.discount,
        totalAmount: cartCount[cartindexArray[i]] * d?.unitPrice,
        quantity: cartCount[cartindexArray[i]],
        CarbonFootPrint: d?.CarbonFootPrint,
        unitPrice: d?.unitPrice,
      }));
    } else {
      products = checkedProduct?.map((d, i) => ({
        id: d?.id,
        productName: d?.name,
        vat: d?.VATPercent,
        discount: d?.discount,
        totalAmount: count[indexArray[i]] * d?.salePrice,
        quantity: count[indexArray[i]],
        CarbonFootPrint: d?.kgco2_co2_unit,
        unitPrice: d?.salePrice,
      }));
    }
    const data = {
      invoiceId: invoiceId,
      totalAmount: totalPrice,
      filterCarbonFootPrint: totalCO2,
      supplierId: supId,
      products: products,
    };
    try {
      const response = await instance.post(
        `/customer/purchase-order/save-order-basket-create-past-order`,
        data
      );

      toast.success(response?.data?.message);
      setCheckedProduct([]);
      setCheckedCartProduct([]);
      setCartIndexArray([]);
      setIndexArray([]);
      getBasketData(supId);
      setShow(false);
      navigate("/purchaseorder");
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const handleSaveBasket = async () => {
    const products = checkedProduct?.map((d, i) => ({
      id: d?.id,
      productName: d?.name,
      vat: d?.VATPercent,
      discount: d?.discount,
      totalAmount: count[indexArray[i]] * d?.salePrice,
      quantity: count[indexArray[i]],
      CarbonFootPrint: d?.kgco2_co2_unit,
      unitPrice: d?.salePrice,
    }));

    const data = {
      supplierId: supId,
      products: products,
    };
    try {
      const response = await instance.post(
        `/customer/purchase-order/save-order-basket`,
        data
      );
      toast.success(response?.data?.message);
      setCheckedProduct([]);
      setCheckedCartProduct([]);
      setCartIndexArray([]);
      setIndexArray([]);
      getBasketData(supId);
      setShow(false);
      // navigate(`/purchaseorder?isDraft=${true}`);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const handledelete = (id, pid) => {
    const data = {
      purchaseOrderId: id,
      productId: pid,
    };
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await instance.post(
            `/customer/purchase-order/delete-basket-product`,
            data
          );
          toast.success(response?.data?.message);
          // handleClose();
          getBasketData(supId);
          console.log("resposne", response);
        } catch (err) {
          toast.error(err?.response?.data?.message);
        }
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="dbMain  purchase">
        <Leftpanel breadcm="Order" />
        <div className="dbRight">
          <Header
            link="/purchaseorder"
            breadcm=""
            title="Create Past Order"
            description=""
          />

          <div className="commonBase mb-3">
            <Form.Group className="row" controlId="exampleForm.ControlInput1">
              <Col sm="2" className="mb-3">
                <Form.Select
                  className="form-control"
                  aria-label="Default select example"
                  onChange={(e) => handleDropdown(e.target.value)}
                >
                  <option>Select Vendor</option>
                  {SupplierDataList?.map((d) => (
                    <option value={d?.id}>{d?.name}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col sm="2" className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Invoice Id"
                  name="invoiceId"
                  onChange={(e) => setInvoiceId(e.target.value)}
                />
              </Col>
              <Col sm="2" className="mb-3">
                <div className="dateSelect delDate">
                  <DatePicker
                    selectsStart
                    maxDate={new Date()}
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    startDate={startDate}
                    placeholderText="Select Date"
                  />
                </div>
              </Col>
              <Col sm="3" className="mb-3">
                <Form.Select
                  className="form-control"
                  aria-label="Default select example"
                  onChange={(e) => handleChangeBU(e.target.value)}
                >
                  <option value="">Select Operator Unit</option>
                  {businesUnitData?.map((d) => (
                    <option value={d?.id}>{d?.name}</option>
                  ))}
                </Form.Select>
              </Col>

              <Col sm="3" className="mb-3">
                <Form.Select
                  className="form-control"
                  aria-label="Default select example"
                  onChange={onDepartment}
                >
                  <option value="">Select Department</option>
                  {myDepartmentList?.map((d) => (
                    <option value={d?.id}>{d?.name}</option>
                  ))}
                </Form.Select>
              </Col>
            </Form.Group>
            <Form.Group className="row" controlId="exampleForm.ControlInput1">
              <Col sm="4" className="mb-3">
                {getSupplierId?.name && (
                  <div className="namecard mb-2 mt-3">
                    <p>Company Name: {getSupplierId?.name}</p>
                    <p>Email : {getSupplierId?.email}</p>
                    <p>Full Address : {getSupplierId?.address}</p>

                    <p>Phone: {getSupplierId?.mobile}</p>
                    <p>State: {getSupplierId?.state}</p>
                    <p>Country: {getSupplierId?.country}</p>
                    <p>Currency: {getSupplierId?.currencyType}</p>
                  </div>
                )}
              </Col>
              <Col sm="4" className="mb-3" />
              <Col sm="4" className="mb-3">
                {departmentList?.map((d) => (
                  <div className="namecard mb-2 mt-3">
                    <p>Name: {d?.name}</p>
                    <p>Short Name: {d?.shortName}</p>
                    <p>BU Identification Number: {d?.buIdentificationNumber}</p>
                    <p>Address: {d?.address}</p>
                  </div>
                ))}
              </Col>
            </Form.Group>
          </div>

          <div className="commonBase mb-3">
            <h6>Create New Product</h6>
            <Formik
              initialValues={{
                productId: "",
                productName: "",
                base_qty: "",
                price: "",
                vat: "",
                discount: "",
                co2: "",
              }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                handleAdd(values);
              }}
            >
              {({
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
                handleSubmit,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group
                    className="row"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Col sm="3" className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Product Id"
                        name="productId"
                        value={values.productId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.productId && !!errors.productId}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.productId}
                      </Form.Control.Feedback>
                    </Col>
                    <Col sm="3" className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Product Name"
                        name="productName"
                        value={values.productName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.productName && !!errors.productName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.productName}
                      </Form.Control.Feedback>
                    </Col>
                    <Col sm="3" className="mb-3">
                      <Form.Control
                        type="number"
                        placeholder="Select Qty"
                        name="base_qty"
                        value={values.base_qty}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.base_qty && !!errors.base_qty}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.base_qty}
                      </Form.Control.Feedback>
                    </Col>
                    <Col sm="3" className="mb-3">
                      <Form.Control
                        type="number"
                        placeholder="Carbon footprint"
                        name="co2"
                        value={values.co2}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.co2 && !!errors.co2}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.co2}
                      </Form.Control.Feedback>
                    </Col>
                    <div className="d-flex">
                      <Form.Check
                        inline
                        label="With VAT"
                        name="group1"
                        type="radio"
                        id="With_VAT"
                        defaultChecked
                        onChange={handleChangeCheckbox}
                      />
                      <Form.Check
                        inline
                        label="Without VAT"
                        name="group1"
                        type="radio"
                        id="Without_VAT"
                        onChange={handleChangeCheckbox}
                      />
                    </div>
                    <Col sm="3" className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Enter price"
                        name="price"
                        value={values.price}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.price && !!errors.price}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.price}
                      </Form.Control.Feedback>
                    </Col>
                    {selectedOption === "Without_VAT" && (
                      <Col sm="3" className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="VAT %"
                          name="vat"
                          value={values.vat}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.vat && !!errors.vat}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.vat}
                        </Form.Control.Feedback>
                      </Col>
                    )}

                    <Col sm="3" className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Discount"
                        name="discount"
                        value={values.discount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.discount && !!errors.discount}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.discount}
                      </Form.Control.Feedback>
                    </Col>

                    <Col sm="3" className="mb-3">
                      <Button variant="success" type="submit">
                        Add
                      </Button>
                    </Col>
                  </Form.Group>
                </Form>
              )}
            </Formik>
          </div>

          {supId && (
            <div className="commonBase mb-3">
              <div className="pastOrderproducttop">
                <h6>Select Product</h6>
                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control"
                  style={{ width: "40%" }}
                  onChange={(e) => handleSearch(e.target.value)}
                />

                <div className="ppoTxt">
                  <span>
                    Total carbon footprint :{" "}
                    <span className="cgbtn">{totalCO2}</span>
                  </span>
                  &nbsp;&nbsp;
                  <span>
                    Total amount : <span className="cgbtn">{totalPrice}</span>
                  </span>
                  &nbsp;&nbsp;
                  <div className="orderCart">
                    <button onClick={handleShow}>
                      <i className="fa-regular fa-cart-shopping"></i>
                      <span className="pop">{busketData?.length}</span>
                    </button>
                  </div>
                </div>
              </div>
              {supplierProduct.length !== 0 && (
                <>
                  <div className="prdviewTable respTable">
                    <table>
                      <thead>
                        <tr>
                          <th>Product ID</th>
                          <th>Product Name</th>
                          <th>Price</th>
                          <th>Carbon footprint</th>
                          <th>VAT %</th>
                          <th>Discount %</th>
                          <th>Select qty</th>
                          <th>Total amount</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {supplierProduct?.map((d, i) => (
                          <tr key={i}>
                            <td data-label="Product ID">
                              <Link to="/purchaseorderdetail"> {d?.id}</Link>
                            </td>
                            <td data-label="Product Name">{d?.name}</td>
                            <td data-label="Price">
                              <span className="defltBg">{d?.salePrice}</span>
                            </td>
                            <td data-label="Carbon footprint">
                              {d?.kgco2_co2_unit}
                            </td>
                            <td data-label="VAT %">
                              <span className="defltBg">{d?.VATPercent}%</span>
                            </td>
                            <td data-label="Discount %">
                              <span className="defltBg">{d?.discount}%</span>
                            </td>
                            <td data-label="Select qty">
                              <div className="defltBg">
                                <button onClick={() => handleDecrement(i)}>
                                  -
                                </button>
                                <span style={{ padding: "0 5px;" }}>
                                  {count[i]}
                                </span>
                                <button onClick={() => handleIncrement(i)}>
                                  +
                                </button>
                              </div>
                            </td>
                            <td data-label="Total amount">
                              {Number(d?.salePrice) * count[i]}
                            </td>
                            <td data-label="Action">
                              <Link to="#">
                                {isSelected(d?.id) ? (
                                  <i
                                    className="fa-solid fa-check"
                                    onClick={() => handleCheckCart(d, i)}
                                  ></i>
                                ) : (
                                  <i
                                    className={`fa-regular fa-cart-shopping ${
                                      count[i] === 0 ? "disabled" : ""
                                    }`}
                                    onClick={() => handleCheckCart(d, i)}
                                  ></i>
                                )}
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <button
                    className="commonButton mt-3"
                    onClick={handleCreateOrder}
                  >
                    Create Order
                  </button>
                  &nbsp;&nbsp;
                  <button
                    className="commonButton mt-3"
                    onClick={handleSaveBasket}
                  >
                    Save the basket
                  </button>
                  &nbsp;&nbsp;
                  <button
                    className="commonButton mt-3"
                    onClick={handleCreateOrderandSaveBasket}
                  >
                    Save Basket & Create Order
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <Modal
        size="lg"
        centered
        show={show}
        onHide={handleClose}
        className="busketModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Cart</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="prdviewTable respTable">
            <table>
              <thead>
                <tr>
                  <th>Product ID</th>
                  <th>Product Name</th>
                  <th>Price</th>
                  <th>Carbon footprint</th>
                  <th>VAT %</th>
                  <th>Discount %</th>
                  <th>Updated date</th>
                  <th>Select qty</th>
                  <th>Total amount</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {busketData?.length !== 0 &&
                  busketData?.map((d, i) => (
                    <tr>
                      <td data-label="Product ID">
                        <Link to="/purchaseorderdetail"> {d?.productId}</Link>
                      </td>
                      <td data-label="Product Name">{d?.productName}</td>
                      <td data-label="Price">
                        <span className="defltBg">{d?.unitPrice}</span>
                      </td>
                      <td data-label="Carbon footprint">
                        {d?.CarbonFootPrint}
                      </td>
                      <td data-label="VAT %">
                        <span className="defltBg">{d?.vat}%</span>
                      </td>
                      <td data-label="Discount %">
                        <span className="defltBg">{d?.discount}%</span>
                      </td>
                      <td data-label="Updated date">
                        {moment(d?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                      </td>
                      <td data-label="Select qty">
                        {/* {d?.quantity} */}

                        <div className="defltBg">
                          <button onClick={() => cartItemDecrement(i)}>
                            -
                          </button>
                          <span style={{ padding: "0 5px;" }}>
                            {cartCount[i]}
                          </span>
                          <button onClick={() => cartItemIncrement(i)}>
                            +
                          </button>
                        </div>
                      </td>
                      <td data-label="Total amount">
                        {cartCount[i] * Number(d?.unitPrice)}
                      </td>
                      {/* <td data-label="check">
                        <input
                          type="checkbox"
                          defaultChecked={isCartSelected(d?.id)}
                          onClick={() => handleCheckCartModal(d, i)}
                        />
                      </td> */}
                      <td data-label="Action">
                        <button
                          className="delIcn"
                          onClick={() =>
                            handledelete(d?.pastOrderCreateId, d?.id)
                          }
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="orderComment pt-3">
            <h6 className="pb-2">Add Comments</h6>
            <textarea></textarea>
            <button className="commonButton mt-3" style={{ float: "right" }}>
              Add
            </button>
            &nbsp;&nbsp;
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start">
          <button
            className="commonButton mt-3"
            onClick={handleCreateOrderandSaveBasket}
          >
            Save Basket & Create Order
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Createpurchaseorder;
